/**
 * Dynamically imports the bootstrap file to initialize the application.
 *
 * For more details on potential errors with Module Federation, see:
 * {@link https://webpack.js.org/concepts/module-federation/#uncaught-error-shared-module-is-not-available-for-eager-consumption}
 */
import('./bootstrap')
